import { useMemo } from 'react';
import styles from '../../GeoBrowse.module.css';

type RatioBarProps = {
  value: number;
  total: number;
  muted?: boolean;
};

export function RatioBar({ value, total, muted }: RatioBarProps) {
  const pct = total > 0 ? (value / total) * 100 : 0;
  return (
    <div className={styles.barCell}>
      <div className={styles.barTrack}>
        <div
          className={`${styles.barFill} ${muted ? styles.barFillMuted : ''}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={styles.barText}>
        {value.toLocaleString()} / {total.toLocaleString()}
      </span>
    </div>
  );
}

type StatusBadgeProps = {
  label: string;
  variant: 'clean' | 'warn' | 'error' | 'neutral' | 'case';
};

export function StatusBadge({ label, variant }: StatusBadgeProps) {
  const className = useMemo(() => {
    switch (variant) {
      case 'clean':
        return styles.badgeClean;
      case 'warn':
        return styles.badgeWarn;
      case 'error':
        return styles.badgeError;
      case 'case':
        return styles.badgeCase;
      default:
        return styles.badge;
    }
  }, [variant]);

  return <span className={`${styles.badge} ${className}`}>{label}</span>;
}

export function InlineBar({
  value,
  max,
  tone = 'accent',
}: {
  value: number;
  max: number;
  tone?: 'accent' | 'green' | 'blue';
}) {
  const pct = max > 0 ? (value / max) * 100 : 0;
  const toneClass = tone === 'green' ? styles.barFillGreen : tone === 'blue' ? styles.barFillBlue : '';
  return (
    <div className={styles.barCell}>
      <div className={styles.barTrack}>
        <div className={`${styles.barFill} ${toneClass}`} style={{ width: `${pct}%` }} />
      </div>
      <span className={styles.barText}>{Number(value ?? 0).toLocaleString()}</span>
    </div>
  );
}
